import { Component } from "@angular/core";
import { MenuItem } from "../../../shared/menu/menu-item.model";

@Component({
  selector: "toolbox-navigation",
  templateUrl: "./navigation.component.html",
  styleUrls: ["./navigation.component.scss"],
})
export class NavigationComponent {
  menuItems = [
    new MenuItem({
      path: "#",
      description: "Item 1",
      iconName: "compass",
      children: [
        new MenuItem({
          path: "#",
          description: "Item 1 - Sub 1",
          iconName: "thumbs-up",
        }),
      ],
    }),
    new MenuItem({
      path: "#",
      description: "Item 2",
      iconName: "palette",
      children: [
        new MenuItem({
          path: "#",
          description: "Item 2 - Sub 1",
          iconName: "microsoft",
        }),
        new MenuItem({
          path: "#",
          description: "Item 2 - Sub 2",
          iconName: "paperclip",
        }),
        new MenuItem({
          path: "#",
          description: "Item 2 - Sub 3",
          iconName: "chart-bar",
        }),
      ],
    }),
    new MenuItem({
      path: "#",
      description: "Item 3",
      iconName: "wifi",
    }),
  ];
}
